import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  PRESS_HOVER,
  PRESS_TAP,
  PRESS_TRANSITION,
} from "../../../../utils/motionInteractions";
const EVENTS_TARGET = "/events/search";

export default function LandingAuthActions({ className = "", compact = false, isAuth = false }) {
  const navigate = useNavigate();
  const { t } = useTranslation("landing");
  const authenticated = isAuth === true;
  const buttonHeight = compact ? "h-[55px]" : "h-[55px] md:h-14";
  const maxWidth = compact ? "max-w-[343px]" : "max-w-[343px] md:max-w-[420px]";
  const iconSize = compact ? "h-5 w-5" : "h-6 w-6";
  const primaryLabel = authenticated
    ? t("section1.cta.enter_vaultgrid")
    : t("section1.auth.login");
  const primaryTarget = authenticated ? EVENTS_TARGET : "/auth?tab=login";

  return (
    <div className={`flex w-full ${maxWidth} flex-col gap-[10px] ${className}`}>
      <motion.button
        type="button"
        whileHover={PRESS_HOVER}
        whileTap={PRESS_TAP}
        transition={PRESS_TRANSITION}
        className={`flex ${buttonHeight} w-full items-center justify-center gap-2 rounded-full bg-[#3f73ff] px-5 text-sm font-bold text-white shadow-[0_16px_42px_rgba(52,112,255,0.36)] transition hover:bg-[#4a7bff] md:text-base`}
        onClick={() => navigate(primaryTarget)}
      >
        <img
          src="/assets/landing/castle-logo.svg"
          alt=""
          className={`${iconSize} brightness-0 invert`}
        />
        {primaryLabel}
      </motion.button>
      {!authenticated && (
        <motion.button
          type="button"
          whileHover={PRESS_HOVER}
          whileTap={PRESS_TAP}
          transition={PRESS_TRANSITION}
          className={`flex ${buttonHeight} w-full items-center justify-center rounded-full border border-white/30 bg-white/[0.08] px-5 text-sm font-bold text-white shadow-[0_16px_42px_rgba(0,0,0,0.20)] backdrop-blur-xl transition hover:bg-white/[0.12] md:text-base`}
          onClick={() => navigate(EVENTS_TARGET)}
        >
          {t("section1.auth.browse_public")}
        </motion.button>
      )}
    </div>
  );
}
